@if (currencies$ | async; as currencies) {
  @if (!!currencies?.length) {
    <ul class="navbar-nav responsive-select">
      <li class="nav-item d-flex align-items-center py-2 px-3">
        @if (currencies?.length === 1) {
          <span class="text-white text-nowrap">{{ currencies[0].description }}</span>
        } @else {
          <select
            class="form-select form-select-sm"
            [(ngModel)]="currencySelectService.currentCurrency"
            [ngModelOptions]="{ standalone: true }"
            (change)="setCurrency($event)"
          >
            @for (currency of currencies$ | async; track currency.id) {
              <option value="{{ currency.id }}" [selected]="currencySelectService.currentCurrency === currency.id">
                {{ currency.description }}
              </option>
            }
          </select>
        }
      </li>
    </ul>
  }
}
